import React, { useState, useEffect } from 'react';
import dryEditorClass from './DryEditorClass';
import FastTooltip from '../../components/FastTooltip';
import constants from '../../constants';

const { EDITOR_COMMAND_NAME_MAP } = constants;

const DEFAULT_FONT_SIZE = 16;
const MIN_FONT_SIZE = 6;
const MAX_FONT_SIZE = 96;

const getFontSizeFromState = (editorState) => {
  if (!editorState) return DEFAULT_FONT_SIZE;
  try {
    const { $from, empty, from, to } = editorState.selection;
    const fontSizeMark = editorState.schema.marks.fontsize;
    if (!fontSizeMark) return DEFAULT_FONT_SIZE;
    if (empty) {
      const mark = $from.marks().find(m => m.type === fontSizeMark);
      return mark ? parseInt(mark.attrs.fontSize, 10) : DEFAULT_FONT_SIZE;
    }
    let found = null;
    editorState.doc.nodesBetween(from, to, (node) => {
      if (node.isText && !found) {
        const mark = node.marks.find(m => m.type === fontSizeMark);
        if (mark) found = parseInt(mark.attrs.fontSize, 10);
      }
    });
    return found || DEFAULT_FONT_SIZE;
  } catch (_) {
    return DEFAULT_FONT_SIZE;
  }
};

const numToSize = (num) => num === DEFAULT_FONT_SIZE ? 'inherit' : `${num}px`;

const FontSizeNudgeButtons = () => {
  const [currentSize, setCurrentSize] = useState(DEFAULT_FONT_SIZE);

  useEffect(() => {
    dryEditorClass.registerTransactionHandler({
      name: 'fontSizeNudge',
      method: (state) => setCurrentSize(getFontSizeFromState(state)),
    });
    return () => dryEditorClass.registeredTransactionHandlers.delete('fontSizeNudge');
  }, []);

  const nudge = (delta, e) => {
    e.preventDefault();
    const next = Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, currentSize + delta));
    dryEditorClass.execCommands([{
      commandName: EDITOR_COMMAND_NAME_MAP.font_size,
      options: { fontSize: numToSize(next) },
    }]);
  };

  return (
    <>
      <FastTooltip title="Decrease font size">
        <button
          className="editor-button font-nudge-btn"
          onMouseDown={(e) => nudge(-1, e)}
          type="button"
          aria-label="Decrease font size"
        >
          <span className="font-nudge-btn__inner font-nudge-btn__inner--shrink">A</span>
        </button>
      </FastTooltip>
      <FastTooltip title="Increase font size">
        <button
          className="editor-button font-nudge-btn"
          onMouseDown={(e) => nudge(1, e)}
          type="button"
          aria-label="Increase font size"
        >
          <span className="font-nudge-btn__inner font-nudge-btn__inner--grow">A</span>
        </button>
      </FastTooltip>
    </>
  );
};

export default FontSizeNudgeButtons;
